import { Typography } from '@material-ui/core'

import { getTranslate } from '../../../../localization'
import useStyles from './styles/index.styles'

type Props = {
  header?: string
  options: { value: string; label: string }[]
  selectedItems: string[]
  setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>
  multiSelectedMode?: boolean
}

const ContentFitList = ({
  header,
  options,
  selectedItems,
  setSelectedItems,
  multiSelectedMode
}: Props) => {
  const classes = useStyles()

  const handleClick = (value: string) => {
    if (!multiSelectedMode) {
      setSelectedItems((prev) => (prev.includes(value) ? [] : [value]))
    } else {
      if (value === 'All') {
        const allValues = options.map((opt) => opt.value)
        const isAllSelected = selectedItems.length === allValues.length
        setSelectedItems(isAllSelected ? [] : allValues)
      } else {
        setSelectedItems((prev) => {
          const isSelected = prev.includes(value)
          let updated = isSelected
            ? prev.filter((item) => item !== value)
            : [...prev, value]

          const allExceptAll = options
            .filter((opt) => opt.value !== 'All')
            .map((opt) => opt.value)

          const isAllNonAllSelected = allExceptAll.every((val) =>
            updated.includes(val)
          )

          if (isAllNonAllSelected && !updated.includes('All')) {
            updated = ['All', ...updated]
          }

          if (!isAllNonAllSelected && updated.includes('All')) {
            updated = updated.filter((val) => val !== 'All')
          }

          return updated
        })
      }
    }
  }

  return (
    <div className={classes.root}>
      {header && (
        <Typography variant="h5" className={classes.title}>
          {header}
        </Typography>
      )}
      {options.map((item) => (
        <div
          key={item.value}
          className={[
            classes.elementName,
            selectedItems.includes(item.value) && classes.selectedElement
          ].join(' ')}
          onClick={() => handleClick(item.value)}>
          <Typography variant="h5" className={classes.text}>
            {getTranslate(item.label)}
          </Typography>
        </div>
      ))}
    </div>
  )
}

export default ContentFitList
